import { createElementBlock as r, openBlock as c, normalizeClass as a, createElementVNode as f, renderSlot as i } from "vue";
import { themeProp as u } from "../../../composables/useTheme.js";
import { sectionProps as $ } from "../mixins/useSectionProps.js";
/* empty css                    */
const B = {
  __name: "section-single",
  props: {
    ...$,
    ...u
  },
  setup(d) {
    const s = d, p = (t) => {
      const m = t === "bottom", l = t === "top", n = s.spaceOptionsSmall, e = s.spaceOptionsMedium;
      let o = "";
      return s.withSpace && (m && s.withSpaceBottom && (n.bottom && (o += `ds-padding-${t}-48`, e.bottom || (o += ` ds-md-padding-${t}-0`)), e.bottom && (o += ` ds-md-padding-${t}-96`)), l && s.withSpaceTop && (n.top && (o += ` ds-padding-${t}-48`, e.top || (o += ` ds-md-padding-${t}-0`)), e.top && (o += ` ds-md-padding-${t}-96`))), o;
    };
    return (t, m) => (c(), r("section", {
      class: a(["ds-section", [`ds-section--${t.theme}`, p("top"), p("bottom")]])
    }, [
      f("div", {
        class: a({ "ds-container": !t.fullScreen })
      }, [
        i(t.$slots, "default")
      ], 2),
      i(t.$slots, "full-screen")
    ], 2));
  }
};
export {
  B as default
};
